import React from "react";
import { Outlet, Navigate } from "react-router-dom";

const PublicRoutes = () => {
  let userInfo = localStorage.getItem("user_info");
  return userInfo ? <Navigate to="/" /> : <Outlet />;
};

export default PublicRoutes;
